import React, { useState, useEffect } from "react";
import axios from "axios";
import { IoMdClose } from "react-icons/io";

const Editproject = ({ isOpen, onClose, project, onUpdate }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    theme_inspiration: "",
    primary_goals: "",
    milestones: "",
    history: "",
    skill_areas: [],
    preferred_support: [],
    timeline: "",
    projectStatus: "",
    image: null,
  });
  const [preview, setPreview] = useState(null);
const preferredSupportOptions = [
  "Peer Buddy",
  "Mentor Matching",
  "Affinity Group",
  "Workshops/Tutorials",
  "Gear Recommendations",
  "Feedback Cycles",
];

const skillAreasOptions = [
  "Composition",
  "Lighting",
  "Editing/Post-Processing",
  "Storytelling",
  "Posing/Directing",
  "Other",
];
  useEffect(() => {
    if (project) {
      setFormData({
        title: project.title || "",
        description: project.description || "",
        theme_inspiration: project.theme_inspiration || "",
        primary_goals: project.primary_goals || "",
        milestones: project.milestones || "",
        history: project.history || "",
        skill_areas: project.skill_areas || [],
        preferred_support: project.preferred_support || [],
        timeline: project.timeline ? project.timeline.split("T")[0] : "",
        projectStatus: project.status || "Not Started",
        image: null, // new image will replace existing one
      });
      setPreview(project.image || null);
    }
  }, [project]);

  if (!isOpen) return null;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };



  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFormData((prev) => ({ ...prev, image: file }));
    setPreview(URL.createObjectURL(file));
  };
const handleCheckboxChange = (field, value) => {
  setFormData((prev) => {
    const arr = prev[field];
    return {
      ...prev,
      [field]: arr.includes(value)
        ? arr.filter((item) => item !== value)
        : [...arr, value],
    };
  });
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    payload.append("data", JSON.stringify(formData));
    if (formData.image) payload.append("image", formData.image);

    try {
      const res = await axios.put(`/api/project/edit/${project._id}`, payload, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        alert("Project updated successfully!");
        onUpdate(res.data.data); // callback to update parent state
        onClose();
      }
    } catch (err) {
      console.error(err);
      alert("Failed to update project.");
    }
  };
  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-xl w-full sm:w-[90%] md:w-[80%] lg:w-[50%] max-h-[90vh] overflow-y-auto p-6 shadow-lg"
      >
        <div className="flex justify-between mb-4">
          <h2 className="text-xl font-bold">Edit Project</h2>
          <button onClick={onClose}>
            <IoMdClose className="text-2xl text-gray-700" />
          </button>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <label>Title</label>
            <input
              name="title"
              value={formData.title}
              onChange={handleChange}
              className="w-full rounded border px-4 py-2"
            />
          </div>

          <div>
            <label>Description</label>
            <textarea
              rows={6}
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w-full rounded border px-4 py-2"
            />
          </div>

          <div>
            <label>Theme Inspiration</label>
            <input
              name="theme_inspiration"
              value={formData.theme_inspiration}
              onChange={handleChange}
              className="w-full rounded border px-4 py-2"
            />
          </div>

          <div>
            <label>Primary Goals</label>
            <textarea
              rows={6}
              name="primary_goals"
              value={formData.primary_goals}
              onChange={handleChange}
              className="w-full rounded border px-4 py-2"
            />
          </div>

          <div>
            <label>Milestones</label>
            <textarea
              rows={6}
              name="milestones"
              value={formData.milestones}
              onChange={handleChange}
              className="w-full rounded border px-4 py-2"
            />
          </div>

          <div>
            <label>Project History</label>
            <textarea
              rows={6}
              name="history"
              value={formData.history}
              onChange={handleChange}
              className="w-full rounded border px-4 py-2"
            />
          </div>

          <div>
            <label>Timeline</label>
            <input
              type="date"
              name="timeline"
              value={formData.timeline}
              onChange={handleChange}
              className="w-full rounded border px-4 py-2"
            />
          </div>

          {/* Skill Areas */}
       <div>
  <h3 className="font-semibold mb-2">Preferred Support</h3>
  <div className="flex flex-wrap gap-4">
    {preferredSupportOptions.map((option) => (
      <label key={option} className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={formData.preferred_support.includes(option)}
          onChange={() => handleCheckboxChange("preferred_support", option)}
        />
        {option}
      </label>
    ))}
  </div>
</div>

<div>
  <h3 className="font-semibold mb-2">Skill Areas to Develop</h3>
  <div className="flex flex-wrap gap-4">
    {skillAreasOptions.map((option) => (
      <label key={option} className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={formData.skill_areas.includes(option)}
          onChange={() => handleCheckboxChange("skill_areas", option)}
        />
        {option}
      </label>
    ))}
  </div>
</div>


          {/* Image Upload */}
          <div>
            <label>Project Image</label>
            <input type="file" onChange={handleFileChange} />
            {preview && (
              <img src={preview} alt="preview" className="w-[400px] h-[400px] object-fill mt-2" />
            )}
          </div>

          <div className="flex justify-end mt-4">
            <button
              type="submit"
              className="px-6 py-2 bg-blue-500 text-white rounded"
            >
              Update Project
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Editproject;
